import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';

const NavbarDropdown = ({companies}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div onClick={() => setIsOpen(!isOpen)} className="navbar-text-archived-company">
        <p>Comptes Archivés :</p>
        {isOpen ? (
          <i className="fas fa-chevron-up" />
        ) : (
          <i className="fas fa-chevron-down" />
        )}
      </div>
      {isOpen &&
        companies.map((company) => (
          <li key={company._id} className="navbar-list-item">
            <NavLink
              to={`/admin/entreprise/${company._id}`}
              activeStyle={{
                color: '#09092D',
                fontWeight: 'bold',
                textDecoration: 'underline',
              }}
              className="navbar-list-link"
            >
              {company.name}
            </NavLink>
          </li>
        ))}
    </div>
  );
};

export default NavbarDropdown;
